import Document from "../general/document";

export interface ProductData {
  description: string;
}

class Product extends Document<ProductData> {
  get title() {
    return this.data.description;
  }
}

export default Product;
